import { BaseFetch } from "../main-model";
export default class AcademicModel extends BaseFetch {
  getAcademicYearBy = (data) =>
    this.authFetch({
      url: "academic-year/getAcademicYearBy",
      method: "POST",
      body: JSON.stringify(data),
    });
  getAcademicYearById = (data) =>
    this.authFetch({
      url: "academic-year/getAcademicYearById",
      method: "POST",
      body: JSON.stringify(data),
    });
  updateAcademicYearById = (data) =>
    this.authFetch({
      url: "academic-year/updateAcademicYearById",
      method: "POST",
      body: JSON.stringify(data),
    });
  insertAcademicYearAll = (data) =>
    this.authFetch({
      url: "academic-year/insertAcademicYearAll",
      method: "POST",
      body: JSON.stringify(data),
    });
  insertAcademicYear = (data) =>
    this.authFetch({
      url: "academic-year/insertAcademicYear",
      method: "POST",
      body: JSON.stringify(data),
    });
  deleteAcademicYearById = (data) =>
    this.authFetch({
      url: "academic-year/deleteAcademicYearById",
      method: "POST",
      body: JSON.stringify(data),
    });
}
